import { FaArrowRight } from "react-icons/fa6";

export default function ArrowRight({size}) {
    return <FaArrowRight size={size} />;
}